export const WATER = "https://static.prod-images.emergentagent.com/jobs/09951202-9645-42a5-a6a2-0e0f3778367d/images/ea39cd4957475fc1d062d941b669b74c3d7e00ad323db18082a74c625fbaf90a.jpeg";


export const NAV = [
  { key: "advisory", label: "Consultancy", eyebrow: "Advisory", section: "LUXEWELL Strategies", to: "/advisory", items: [
    ["Strategic Advisory", "/advisory#strategic-advisory"],
    ["Business Development", "/advisory#business-development"],
    ["Brand Visibility", "/advisory#brand-visibility"],
    ["WELLTHSPAN™ Audit", "/advisory#wellthspan-index"],
  ] },
  { key: "experiences", label: "Conciergerie", eyebrow: "Agency", section: "LUXEWELL Experiences", to: "/experiences", items: [
    ["Longevity", "/experiences#longevity"],
    ["Leisure", "/experiences#leisure"],
    ["Lifestyle", "/experiences#lifestyle"],
    ["Curation", "/experiences#the-curation"],
  ] },
  { key: "list", label: "Connectivity", eyebrow: "Assembly", section: "LUXEWELL Communities", to: "/list", items: [
    ["The LIST", "/list#the-list"],
    ["The LOUNGE", "/list#the-lounge"],
    ["The LIFESTYLE", "/list#the-lifestyle"],
    ["The LEGACY", "/list#the-legacy"],
  ] },
  { key: "founders", label: "Founders", to: "/founders" },
  { key: "speakers", label: "Speaking", to: "/speakers" },
];

export const INTERESTS = {
  advisory: "The Consultancy",
  experiences: "The Conciergerie",
  connectivity: "The Connectivity",
  list: "The Connectivity",
  lounge: "The Connectivity",
  lifestyle: "The Connectivity",
  wellthspan: "WELLTHSPAN™ Audit",
  speaking: "Speaking & Seminars",
  legacy: "The LEGACY (Cultural Celebrations & Family Investments)",
  sabbaticals: "Strategic Sabbaticals™ & Regenerative Retreats™",
};
